import React, { useContext } from 'react';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import UserContext from '../../../hooks/UserContext';
import { canEditClinics } from './clinicAccess';

import Details from './Detail';
import Overview from './Overview';
import New from './New';

const Supplynetwork = (props) => {
  const paths = {
    new: `${props.match.path}/new`,
    details: `${props.match.path}/:userId`,
    search: `${props.match.path}/search/:search?`,
  };

  // Ohne Schreibrecht (z. B. Recht "Auswertung") keine editierbare Neu-Maske.
  const canCreate = canEditClinics(useContext(UserContext));

  return (
    <Switch>
      <Route
        path={paths.new}
        render={(routeProps) =>
          canCreate ? (
            <New {...routeProps} />
          ) : (
            <Redirect to={props.match.url} />
          )
        }
      />
      <Route path={paths.search} component={Overview} />
      <Route path={paths.details} component={Details} />
      <Route component={Overview} />
    </Switch>
  );
};

export default withRouter(Supplynetwork);
